import { priceReviver } from '../model/price';
export const backendResponseReviver = (key, value) => {
  return priceReviver(key, value);
};